import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM, readonlyToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class FormSchemaPlugin extends SchemaPlugin {
  nodes = {
    form: {
      group: 'block',
      content: 'block+',
      defining: true, // Persist and wrap the inserted content during replace operations
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{
        tag: 'form'
      }],
      toDOM(node) { return nodeToDOM(node); }
    },

    label: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'label',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); }
    },

    input: {
      group: 'inline',
      inline: true,
      atom: true,
      definingForContent: true,
      attrs: {
        type: { default: undefined }
      },
      parseDOM: [{
        tag: 'input',
        getAttrs: function (dom: HTMLElement) {
          return getSchemaAttrs(dom, ['type']);
        }
      }],
      toDOM(node) { return readonlyToDOM(node); },
      isVoid: true
    },

    select: {
      group: 'block',
      content: 'inline*',
      atom: true,
      parseDOM: [{
        tag: 'select'
      }],
      toDOM(node) { return readonlyToDOM(node); }
    },

    textarea: {
      group: 'block',
      content: 'inline*',
      atom: true,
      parseDOM: [{
        tag: 'textarea'
      }],
      toDOM(node) { return readonlyToDOM(node); }
    }
  } satisfies Record<string, NodeSpec>;
}
